module.exports = __webpack_public_path__ + "static/media/login.e6f89392.jpeg";